/**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);

let opened = false;

const $btnMenu        = $el.find('.menu-hamburguer');
const $menu           = $el.find('#wrap-menu');
const $links          = $menu.find('a');
const $ariaHidden     = $el.find('.aria-hidden');
const $hamburgerInner = $el.find('.hamburger-inner');
const $keepPosition   = $el.find('.keep-position');
const $headerBar      = $el.find('.header-bar');
const $visibleContent = $('.visible-content');

let lastScrollTop = $window.scrollTop();

const keepPosition = () => {
    $keepPosition.removeAttr('style');

    $keepPosition.each(function() {
        const $this = $(this);

        const offset = $this.offset();
        const posY   = offset.top - $window.scrollTop();
        const posX   = offset.left - $window.scrollLeft();

        setTimeout(function() {
            $this.css({top: posY, left: posX, position: 'fixed'});
        }, 100);
    });
}

$window
.on('resize', function () {
    if (wW < 1023) {
        if (opened === false) {
            $ariaHidden.attr('aria-hidden', 'true');
        } else {
            $ariaHidden.attr('aria-hidden', 'false');
        }
    } else {
        $ariaHidden.removeAttr('aria-hidden');
    }

    if ($el.hasClass('is-active')) {
        keepPosition();
        $menu.height(wH);
    } else {
        $menu.removeAttr('style');
        $keepPosition.removeAttr('style');
        $ariaHidden.removeAttr('style');
    }
})
.on('scroll', function () {
    if (wW > 1023) {
        const scrollTop = $window.scrollTop();

        if (scrollTop >= $headerBar.outerHeight()) {
            $body.addClass('menu-fixed');
        } else {
            $body.removeClass('menu-fixed');
        }

        lastScrollTop = scrollTop;
    }
});

$el.find('.goto-menu').on('click', function() {
    $el.find('.oinstituto').focus();
});

$links.on('click', function(e) {
    $el.trigger('menu:close');
});

$btnMenu.on('click', function(e) {
    e.preventDefault();

    if (opened === false) {
        $el.trigger('menu:open');
    } else {
        $el.trigger('menu:close');
    }
});

const verifyContrast = () => {
    if(localStorage.contrast == 1) {
        $body.addClass('contrast');
    } else {
        $body.removeClass('contrast');
    }
}
verifyContrast();

$el.find('.btn-contrast').on('click', function() {
    if(localStorage.contrast == 1) {
        localStorage.contrast = 0;
    } else {
        localStorage.contrast = 1;
    }

    verifyContrast();
});

document.body.addEventListener('click', function (event) {
    if (event.target.nodeName == 'A' && event.target.getAttribute('aria-disabled') == 'true') {
        event.preventDefault();
    }
});

$el.on('menu:open', function(e) {
    opened = true;
    trapFocus($el);

    $body.addClass('modal-opened');
    $hamburgerInner.text('Fechar Menu');

    keepPosition();

    TweenLite.to($ariaHidden, .4, { alpha: 1, ease: Power2.easeInOut });
    TweenLite.to($menu, .4, { height: wH, ease: Power2.easeInOut });

    $el.add($btnMenu).addClass('is-active');

    $btnMenu.attr('aria-expanded', 'true');
    $visibleContent.attr('aria-hidden', 'true');
    $ariaHidden.attr({
        'aria-hidden': 'false',
        'open': 'true'
    });
});

// Modal Hide
$el.on('keyup', function(e) {
    if (e.keyCode === 27 ) {
        $el.trigger('menu:close');
    };
});

$el.on('menu:close', function() {
    opened = false;

    if (wW < 1023) {
        $hamburgerInner.text('Abrir Menu');

        TweenLite.to($ariaHidden, .4, { alpha: 0, ease: Power2.easeInOut });
        TweenLite.to($menu, .4, { height: '71px', ease: Power2.easeInOut, onComplete: () => {
            $keepPosition.removeAttr('style');
            $body.removeClass('modal-opened');
            $el.add($btnMenu).removeClass('is-active');
            $btnMenu.focus();

            $btnMenu.attr('aria-expanded', 'false');
            $ariaHidden.attr('aria-hidden', 'true');
            $ariaHidden.removeAttr('open tabindex');
            $visibleContent.attr('aria-hidden', 'false');
        } });
    }
});
